import Backbone from 'backbone';

/**
 * A messaging system that queues a message to show at a certain time and
 * decides which message shows at which time (based on which function is called).
 *
 * Gets message objects passed-in that have "key" field and can contain other
 * fields for showing in the message content, such as startDate or endDate of
 * the Activity Date Filter.
 */
export default Backbone.Model.extend({

	/**
	 * Private data
	 */
	tempMessage: false,

	/**
	 * Model attributes available for outside observation
	 */
	defaults: {
		message: false
	},

	/**
	 * Bind the filter model so we can check what the state of filter is and
	 * use it for content in messages.
	 */
	/**
	 * Initialize the model
	 * Bind the filterModel and statementLinksObject argument
	 * @param options.filterModel - FilterModel instance - required
	 */
	initialize(options) {
		if (!options) {
			throw new Error('filterModel and statementLinksObject instances are required');
		}

		if (!options.filterModel) {
			throw new Error('filterModel instance is required');
		}

		if (!options.statementLinksObject) {
			throw new Error('statementLinksObject is required');
		}

		// need the model with all the methods that controls biz logic
		this.filterModel = options.filterModel;

		// static data object needed for dynamic content
		this.set('statementLinks', options.statementLinksObject);
	},

	/**
	 * Creates and queue a message regarding activity search result for showing later.
	 * NOTE: Whatever this gets called with overwrites the last thing that was set
	 */
	queueMessageFromResults(options = {}) {
		let message = {
			showMessage: true
		};
		let selectedFilters = this.filterModel.get('transactionFilter');
		let noOfTransactions = options.noOfTransactions;

		// count of transactions
		if (noOfTransactions > 0) {
			message.transactionCount = noOfTransactions;
		} else {
			message.resultPluralKey = 'zero'; // "You don't have any transactions"
		}

		if (this.tempMessage) {
			// retain the headerKey pre-queued value (startDateTooEarly or whatnot)
			message.headerKey = this.tempMessage.headerKey;
		}

		if (this.filterModel) {
			let freeTextSearch = this.filterModel.get('freeTextSearch'),
				currencyCodeData = this.filterModel.get('currencyCodes'),
				selectedCurrency = this.filterModel.get('selectedCurrency');

			if (selectedFilters) {
				message.transactionFilter = selectedFilters;
			}

			if (freeTextSearch) {
				message.freeTextSearch = freeTextSearch;
			}

			if (selectedCurrency && currencyCodeData) {
				let selectedCurrencyData = currencyCodeData.find(function(currencyData) {
					return currencyData.currencyCode === selectedCurrency;
				});
				message.selectedCurrency = selectedCurrencyData;
			}

			// Do not set showMessage to false, if resultPluralKey exists in message object.
			if (!message.resultPluralKey) {
				if (!freeTextSearch && !selectedFilters && !selectedCurrency) {
					message.showMessage = false;
				}
			}
		}

		// queue message to show after spinner goes away and results are rendered
		this.tempMessage = message;
	},

	clearMessage() {
		this.unset('message');
	},

	/**
	 * Check if there is a message in queue and set it on the model if there is one.
	 */
	checkToShowMessage() {
		if (this.tempMessage) {
			this.set('message', this.tempMessage);
			this.tempMessage = false;
		}
	}
});



// WEBPACK FOOTER //
// ./model/activity/messageModel.es6